import { EventKioskResults } from './EventKioskResults';
import { useHistory } from 'react-router-dom';

import { Loading } from '../../components/shared/Loading';
import { useMasterEvent } from '../../hooks/useMasterEvent';

export const MasterEventKiosk = ({ beta, eventId, masterId, isMobile, mode }) => {
  const history = useHistory();

  const { masterEvent, isMasterEventFetching } = useMasterEvent(masterId, eventId)

  if (isMasterEventFetching) {
    return <Loading centered={true}/>;
  }

  return (
    <div>
      <EventKioskResults
        beta={beta}
        eventId={eventId || masterEvent.prevRaceID}
        isMobile={isMobile}
        masterEvent={masterEvent}
        masterId={masterId}
        mode={mode}
        history={history}
      />
      <div id="hiddenCanvas" hidden="hidden"></div>
    </div>
  );
};
